import { Routes } from '@angular/router';
import { AuthSuccessComponent } from './app/auth/success.component';
import { AuthUnauthorizedComponent } from './app/auth/unauthorized.component';
import { LoginComponent } from './app/auth/login.component';
import { DashboardComponent } from './app/dashboard/dashboard.component';
import { AuthGuard } from './app/auth/auth.guard';

export const appRoutes: Routes = [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'auth/success', component: AuthSuccessComponent },
    { path: 'auth/unauthorized', component: AuthUnauthorizedComponent },
    { path: 'auth/login', component: LoginComponent },
    { path: '**', redirectTo: '/auth/login' }
];
